module.exports = __webpack_public_path__ + "img/Weapon_59.f524d493.png";